var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { reaction } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useOnMount } from '../../hooks/lifecycle.hooks';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { IconDefs } from '../Symbols/iconDefs';
import { activateIcon } from '../Symbols/Symbols';
import './BaseIcon.css';
var hasIcon = function (name, variant) {
    var _a;
    return Boolean((_a = IconDefs[name]) === null || _a === void 0 ? void 0 : _a[variant]);
};
var BaseIcon = React.memo(function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get name() {
            var _a, _b;
            return (_b = (_a = p.name) !== null && _a !== void 0 ? _a : p.icon) !== null && _b !== void 0 ? _b : 'arrow';
        },
        get variant() {
            switch (p.variant) {
                case 'color':
                    return hasIcon(s.name, 'color') ? 'color' : hasIcon(s.name, 'filled') ? 'filled' : 'regular';
                case 'filled':
                    return hasIcon(s.name, 'filled') ? 'filled' : 'regular';
                default:
                    return 'regular';
            }
        },
        get id() {
            return s.name + "-" + s.variant;
        }
    }); });
    useOnMount(function () { return reaction(function () { return s.id; }, function () { return activateIcon(s.name, s.variant); }, { fireImmediately: true }); });
    return React.createElement(Observer, { children: function () { return React.createElement("svg", { className: joinClassName('BaseIcon', p.className), width: "24", height: "24", viewBox: "0 0 24 24", "data-name": p.name, "data-variant": p.variant, onClick: p.onClick, style: __assign({ width: p.size, height: p.size, color: p.color }, p.style) },
            p.title && React.createElement("title", null, p.title),
            React.createElement("use", { xlinkHref: "#icon-" + s.id })); } });
});
export default BaseIcon;
